// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RIzO","question":"styles_question__2ywiv","description":"styles_description__pegNF"};